export enum ErpFeatureKeys {
  TEST_STORYBOOK = "test_storybook",
  FEATURE_HISTORIC_INVOICES_ENDPOINT = "ovc_api_historic_invoices",
  PRICE_STABLE_API = "ovc_api_price_stable",
  PRICE_STABLE_ERP = "ovc_erp_price_stable"
  // ... add more features here
}

export const ErpAllFeatureKeys: string[] = Object.values(ErpFeatureKeys);

export interface ErpFeatureState {
  isEnabled: boolean;
  params: Record<string, unknown>;
}

export type ErpFeaturesMap = {
  [key in ErpFeatureKeys]?: ErpFeatureState;
};

export interface FeatureConfigResponse {
  create_date: null | string;
  name: string;
  params: Record<string, unknown>;
  value: boolean;
}

export type CheckFeaturesResponse = {
  [key in ErpFeatureKeys]?: FeatureConfigResponse;
};
